import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { MaterialContext } from "../../context/MaterialContext";
import {
  DEFAULT_PRICE_MAX,
  DEFAULT_PRICE_MIN,
  saveAdminSettings,
} from "../../utilities/adminSettings";

function VendorSettings() {
  const { priceBounds, changePriceBounds } = useContext(MaterialContext);
  const [priceMin, setPriceMin] = useState(
    String(priceBounds?.min ?? DEFAULT_PRICE_MIN),
  );
  const [priceMax, setPriceMax] = useState(
    String(priceBounds?.max ?? DEFAULT_PRICE_MAX),
  );
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSave = (event) => {
    event.preventDefault();
    const minValue = Number(priceMin);
    const maxValue = Number(priceMax);
    if (
      !Number.isFinite(minValue) ||
      !Number.isFinite(maxValue) ||
      minValue < 0 ||
      minValue >= maxValue
    ) {
      setError("Min must be a number 0 or greater, and less than max.");
      setMessage("");
      return;
    }

    const next = saveAdminSettings({
      priceMin: minValue,
      priceMax: maxValue,
    });
    if (typeof changePriceBounds === "function") {
      changePriceBounds(next.priceMin, next.priceMax);
    }
    setPriceMin(String(next.priceMin));
    setPriceMax(String(next.priceMax));
    setError("");
    setMessage(
      `Library price filter is now $${next.priceMin.toFixed(2)}–$${next.priceMax.toFixed(2)} on this browser.`,
    );
  };

  return (
    <div className="content pricingPage">
      <div className="pricingSheet">
        <header className="pricingIntro">
          <h2>Settings</h2>
          <p>
            VendorAdmin only. These values stay on this browser until we store
            them on the API. They do not change material prices.
          </p>
        </header>

        <section className="pricingPreview">
          <h3 className="settingsSectionTitle">Library price filter</h3>
          <form onSubmit={handleSave}>
            <div className="settingsFields">
              <label htmlFor="price-min">
                Min
                <input
                  id="price-min"
                  type="number"
                  min="0"
                  step="0.1"
                  value={priceMin}
                  onChange={(event) => setPriceMin(event.target.value)}
                />
              </label>
              <label htmlFor="price-max">
                Max
                <input
                  id="price-max"
                  type="number"
                  min="0"
                  step="0.1"
                  value={priceMax}
                  onChange={(event) => setPriceMax(event.target.value)}
                />
              </label>
            </div>
            {error ? <p className="pricingError">{error}</p> : null}
            {message ? <p className="pricingSuccess">{message}</p> : null}
            <button className="button-highlight" type="submit">
              Save range
            </button>
          </form>
        </section>

        <section className="pricingPreview settingsTools">
          <h3 className="settingsSectionTitle">Admin tools</h3>
          <p className="pricingHint">
            Same pages as the user menu. Settings is the hub so they are easier
            to find.
          </p>
          <div className="pricingActions">
            <Link className="button-highlight" to="/material/price">
              Price Update
            </Link>
            <Link className="button-highlight" to="/register">
              Register account
            </Link>
            <Link className="button-highlight" to="/material/add">
              Add/Edit Materials
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}

export default VendorSettings;
